import React from 'react'
import { View, ViewStyle, TextStyle, Platform } from 'react-native'
import { SectionHeader } from '../section-header/section-header'
import { color, spacing } from '../../theme'
import { Text } from '../text'

export interface QuizDataProps {
  endDate: string | null
  maxAttempts: number
  questionCount: number
  completedAttempts: number
}

export const QuizData = (props: QuizDataProps) => {
  const { endDate, maxAttempts, completedAttempts, questionCount } = props

  const formattedDate = endDate
    ? new Date(endDate).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : ''

  return (
    <View style={{ marginBottom: 8 }}>
      <SectionHeader headerTx="Quiz.about" />
      <View style={ABOUT}>
        <Text
          style={ATTEMPTSLEFT}
          tx={maxAttempts === 999999 ? 'Quiz.unlimitedAttemptsLeft' : 'Quiz.attemptsLeft'}
          txOptions={maxAttempts === 999999 ? {} : { count: maxAttempts - completedAttempts }}
        />
        <Text style={METADATA} tx="Quiz.numQuestions" txOptions={{ count: questionCount }} />
        {endDate ? (
          <Text style={METADATA} tx="Quiz.availableUntil" txOptions={{ date: formattedDate }} />
        ) : null}
      </View>
    </View>
  )
}

const METADATA: TextStyle = {
  color: 'rgba(0,0,0,.5)',
  fontWeight: '500',
  fontSize: 16,
  lineHeight: 20,
  paddingBottom: 15,
}
const ATTEMPTSLEFT: TextStyle = {
  color: color.darkOrange,
  fontWeight: '600',
  fontSize: 16,
  lineHeight: 20,
  paddingBottom: 15,
}
const ABOUT: ViewStyle = {
  justifyContent: 'space-evenly',
  flexDirection: 'column',
  paddingHorizontal: Platform.OS === 'android' ? spacing[4] : 0,
}
